/* Djurslottet enhancements:
   1) Variant PRICE inside the product page's MAIN add-to-cart button (+ sticky bar).
   2) THUMBNAILS follow the main image smoothly.
   3) QUICK-ADD MODAL: original native variant picker instead of the custom cards.
   Native cart behavior lives in the native cart assets; dormant Opus hooks are intentionally absent.
   Additive, idempotent, no core-theme files touched.

   2026-08-20 (prestanda): observatoren pa produktsidan lyssnade aven pa characterData,
   och aterstallningen skriver sjalv text i samma trad - varje prisandring startade darfor
   en ny runda. characterData ar borttaget och aterstallningen ar strypt med 150 ms fordrojning.
   Svenska bokstaver byggs ur teckenkoder sa filen kan sparas via API:et. */
(function () {
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function onProductPage() { return location.pathname.indexOf('/products/') > -1; }

  var AA = String.fromCharCode(229); /* a med ring */
  var DOT = String.fromCharCode(183); /* mittpunkt */
  var SOLDOUT_RE = new RegExp('sluts' + AA + 'ld|sold\\s*out|ej i lager|utsl' + AA + 'ld', 'i');

  if (!document.getElementById('dj-atc-style')) {
    var st = document.createElement('style');
    st.id = 'dj-atc-style';
    st.textContent = '.dj-atc-price{margin-left:6px;font-weight:600;opacity:.94;white-space:nowrap;}'
      + '@media (max-width:749px){'
      + '.product-form-buttons--stacked{flex-direction:row !important;flex-wrap:nowrap !important;align-items:stretch !important;gap:8px !important;}'
      + '.product-form-buttons--stacked > .quantity-selector-wrapper{flex:0 0 auto !important;}'
      + '.product-form-buttons--stacked > span:last-child{flex:1 1 auto !important;min-width:0 !important;}'
      + '.product-form-buttons--stacked .add-to-cart-text{flex-wrap:wrap !important;row-gap:1px;}'
      + '.product-form-buttons--stacked .add-to-cart-text__content{white-space:nowrap;}'
      + '.product-form-buttons--stacked .dj-atc-price{flex:0 0 100% !important;margin-left:0 !important;text-align:center;font-size:.8em;line-height:1.1;opacity:.92;}'
      + '}'
      + '.quick-add-modal .dj-vp{display:none !important;}'
      /* collapse EMPTY Shopify app blocks (size-chart / subscription app that render nothing on non-subscription products) so they do not each eat a flex row-gap under the variant picker; a block with real UI (active subscription radios) has element content in its div so :has(div *) keeps it visible - subscription products are never hidden */
      + '.product-information__grid .layout-panel-flex > .shopify-app-block:not(:has(> :not(style):not(script):not(link):not(noscript):not(div))):not(:has(div *)){display:none !important;}'
      /* quick-add popup: keep the add-to-cart icon + label on ONE row (the label is shortened via JS) */
      + '.quick-add-modal button[name="add"] .add-to-cart-text{display:flex !important;flex-direction:row !important;flex-wrap:nowrap !important;align-items:center;gap:6px;}'
      + '.quick-add-modal button[name="add"] .add-to-cart-text__content{white-space:nowrap;}'
      /* Horizon hides deferred media in quick add; restore the existing player without enabling image zoom. */
      + '.quick-add-modal .product-media deferred-media{display:block !important;width:100%;height:100%;pointer-events:auto !important;}'
      /* quick-add popup: make the thumbnail strip clickable (theme sets pointer-events:none on the gallery); dj scrolls the image into view on click */
      + '.quick-add-modal__content .product-information__media slideshow-controls,.quick-add-modal__content .product-information__media .slideshow-controls__thumbnail,.quick-add-modal__content .product-information__media slideshow-control{pointer-events:auto !important;cursor:pointer;}';
    (document.head || document.documentElement).appendChild(st);
  }

  /* ---------- 3) Quick-add modal: reveal native picker, hide custom cards ---------- */
  function bindModalMediaSync(modal) {
    var wrap = modal.querySelector('.product-information__media');
    if (!wrap || wrap.__djMediaSync) return;
    wrap.__djMediaSync = true;
    var raf = 0;
    function sync() {
      raf = 0;
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      var slides = Array.prototype.slice.call(modal.querySelectorAll('slideshow-slide'));
      var thumbs = Array.prototype.slice.call(modal.querySelectorAll('.slideshow-controls__thumbnail'));
      if (!slides.length || slides.length !== thumbs.length) return;
      var box = wrap.getBoundingClientRect();
      var best = 0, bestVisible = -1, bestTop = Infinity;
      slides.forEach(function (slide, idx) {
        var rect = slide.getBoundingClientRect();
        var visible = Math.max(0, Math.min(rect.bottom, box.bottom) - Math.max(rect.top, box.top));
        var topDistance = Math.abs(rect.top - box.top);
        if (visible > bestVisible + 0.5 || (Math.abs(visible - bestVisible) <= 0.5 && topDistance < bestTop)) {
          best = idx;
          bestVisible = visible;
          bestTop = topDistance;
        }
      });
      var selected = -1;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('aria-selected') === 'true') { selected = i; break; }
      }
      if (selected === best) return;
      var slideshow = modal.querySelector('slideshow-component');
      if (slideshow && typeof slideshow.current === 'number') {
        slideshow.current = best;
      } else {
        thumbs.forEach(function (thumb, idx) { thumb.setAttribute('aria-selected', idx === best ? 'true' : 'false'); });
      }
    }
    wrap.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(sync);
    }, { passive: true });
    sync();
  }
  function fixModalVariants() {
    var modals = qa('dialog.quick-add-modal[open], .quick-add-modal[open]');
    modals.forEach(function (modal) {
      bindModalMediaSync(modal);
      var vp = modal.querySelector('.dj-vp');
      if (vp) vp.style.setProperty('display', 'none', 'important');
      // Reveal the native picker EVERY tick (no one-time guard): the theme's desktop whitelist
      // CSS keeps hiding it (it lives OUTSIDE variant-picker) and the modal content can be
      // re-rendered late, so re-assert the inline reveal styles idempotently while the modal is open.
      var native = modal.querySelector('.dj-vp-native');
      if (native) {
        native.style.setProperty('display', 'block', 'important');
        native.style.setProperty('position', 'static', 'important');
        native.style.setProperty('width', 'auto', 'important');
        native.style.setProperty('height', 'auto', 'important');
        native.style.setProperty('overflow', 'visible', 'important');
        native.style.setProperty('clip', 'auto', 'important');
        native.style.setProperty('clip-path', 'none', 'important');
        native.style.setProperty('white-space', 'normal', 'important');
        native.style.setProperty('pointer-events', 'auto', 'important');
        native.style.marginTop = '6px';
      }
      // Make the popup thumbnail strip CLICKABLE (theme blocks it with pointer-events:none
      // and a native click doesn't scroll the vertical media column). Re-enable clicks and,
      // on a thumbnail click, scroll the matching image into view in the media scroller.
      var ctrls = modal.querySelector('slideshow-controls');
      if (ctrls) ctrls.style.setProperty('pointer-events', 'auto', 'important');
      if (!modal.__djThumbs) {
        modal.__djThumbs = true;
        modal.addEventListener('click', function (e) {
          var thumb = e.target && e.target.closest ? e.target.closest('.slideshow-controls__thumbnail, slideshow-control') : null;
          if (!thumb || !modal.contains(thumb)) return;
          var thumbs = Array.prototype.slice.call(modal.querySelectorAll('.slideshow-controls__thumbnail, slideshow-control'));
          var idx = thumbs.indexOf(thumb);
          var wrap = modal.querySelector('.product-information__media');
          var slides = modal.querySelectorAll('slideshow-slide');
          if (idx < 0 || !wrap || !slides[idx]) return;
          var target = wrap.scrollTop + (slides[idx].getBoundingClientRect().top - wrap.getBoundingClientRect().top);
          // NOTE: wrap.scrollTo({behavior:'smooth'}) silently does nothing on this element
          // (the media-gallery inside is position:absolute/sticky); direct scrollTop works, so
          // animate scrollTop by hand for a smooth jump to the clicked image.
          var start = wrap.scrollTop, t0 = 0;
          function step(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / 260); wrap.scrollTop = start + (target - start) * (p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2); if (p < 1) requestAnimationFrame(step); }
          requestAnimationFrame(step);
          // If the clicked image is a VIDEO slide, start it playing (the theme's deferred-media
          // only loads/plays on a poster-button click). Enable pointer-events so its controls work.
          var dm = slides[idx].querySelector('deferred-media');
          if (dm) {
            dm.style.setProperty('pointer-events', 'auto', 'important');
            if (!dm.querySelector('video, iframe')) {
              var pb = dm.querySelector('.deferred-media__poster-button');
              if (pb) { try { pb.click(); } catch (er) {} }
            }
          }
        }, true);
      }
    });
  }
  var modalFixFrame = 0;
  function scheduleModalFix() {
    if (modalFixFrame) return;
    modalFixFrame = requestAnimationFrame(function () {
      modalFixFrame = 0;
      fixModalVariants();
    });
  }

  function installQuickAddFix() {
    if (document.__djQaFix) return;
    document.__djQaFix = true;

    function bindModal() {
      var modal = q('dialog.quick-add-modal, .quick-add-modal');
      if (!modal) return false;

      if (!modal.__djQaOpenObserver) {
        modal.__djQaOpenObserver = true;
        new MutationObserver(scheduleModalFix).observe(modal, {
          attributes: true,
          attributeFilter: ['open']
        });
      }

      var content = modal.querySelector('#quick-add-modal-content, .quick-add-modal__content');
      if (content && !content.__djQaContentObserver) {
        content.__djQaContentObserver = true;
        new MutationObserver(scheduleModalFix).observe(content, {
          childList: true,
          subtree: true
        });
      }

      scheduleModalFix();
      return true;
    }

    if (!bindModal()) {
      var bootObserver = new MutationObserver(function () {
        if (bindModal()) bootObserver.disconnect();
      });
      bootObserver.observe(document.documentElement, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target && target.closest &&
        target.closest('.quick-add__button--choose, quick-add-component'))) return;
      setTimeout(bindModal, 0);
      setTimeout(bindModal, 160);
    }, true);

    document.addEventListener('shopify:section:load', bindModal);
  }

  /* ---------- 1) Price in the MAIN add-to-cart button ---------- */
  var CARD_SEL = 'product-card,.product-card,.card-gallery,quick-add-component,.quick-add,.quick-add-modal,[class*="quick-add"],.product-recommendations,.complementary-products,.resource-list';
  function currentPrice() {
    var pps = qa('product-price');
    for (var i = 0; i < pps.length; i++) {
      if (!pps[i].closest(CARD_SEL)) { var el = pps[i].querySelector('.price'); if (el) return el.textContent.replace(/\s+/g, ' ').trim(); }
    }
    return '';
  }
  // Quantity from the MAIN product form's quantity input (never a card).
  function currentQty() {
    var inputs = qa('input[name="quantity"]');
    for (var i = 0; i < inputs.length; i++) { if (!inputs[i].closest(CARD_SEL)) { var v = parseInt(inputs[i].value, 10); return (v > 0) ? v : 1; } }
    return 1;
  }
  function priceNum(s) { var n = parseFloat(String(s).replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.')); return isNaN(n) ? 0 : n; }
  function fmtKr(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr'; }
  function mainButtons() {
    // ONLY the product page's main add button. NOT the sticky bar button: the sticky
    // bar already shows the price on the left, and squeezing the price into the narrow
    // sticky button left a stray middot (looked like a white dot) on mobile.
    var out = [];
    qa('button[name="add"]').forEach(function (b) { if (!b.closest(CARD_SEL) && !b.closest('.sticky-add-to-cart, sticky-add-to-cart')) out.push(b); });
    return out;
  }
  function injectPrice() {
    var targets = mainButtons();
    qa('.dj-atc-price').forEach(function (s) {
      var btn = s.closest('.sticky-add-to-cart__button, button[name="add"]');
      if (!btn || targets.indexOf(btn) < 0) s.remove();
    });
    if (!targets.length) return;
    var base = currentPrice();
    var qty = currentQty();
    var unit = priceNum(base);
    // Total for the chosen quantity: multiply when qty > 1, else keep the theme's exact string.
    var price = (qty > 1 && unit > 0) ? fmtKr(unit * qty) : base;
    targets.forEach(function (btn) {
      var soldout = btn.disabled || SOLDOUT_RE.test(btn.textContent);
      var host = btn.querySelector('.add-to-cart-text') || btn;
      var span = btn.querySelector('.dj-atc-price');
      if (soldout || !price) { if (span) span.remove(); return; }
      if (!span) { span = document.createElement('span'); span.className = 'dj-atc-price'; }
      if (span.parentElement !== host) host.appendChild(span);
      var txt = DOT + ' ' + price;
      if (span.textContent !== txt) span.textContent = txt;
    });
  }

  /* ---------- 2) Thumbnails follow the main image (smooth, on settle) ---------- */
  function gallery() {
    var mg = q('media-gallery');
    if (!mg) return null;
    var main = mg.querySelector('slideshow-slides');
    var thumbs = qa('.slideshow-controls__thumbnail', mg);
    return (main && thumbs.length) ? { mg: mg, main: main, thumbs: thumbs } : null;
  }
  function hScroller(el) {
    var n = el;
    while (n && n !== document.body) {
      if (n.scrollWidth > n.clientWidth + 2) { var ox = getComputedStyle(n).overflowX; if (ox === 'auto' || ox === 'scroll') return n; }
      n = n.parentElement;
    }
    return null;
  }
  function vScroller(el) {
    var n = el;
    while (n && n !== document.body) {
      if (n.scrollHeight > n.clientHeight + 2) { var oy = getComputedStyle(n).overflowY; if (oy === 'auto' || oy === 'scroll') return n; }
      n = n.parentElement;
    }
    return null;
  }
  function centerNow(thumb) {
    if (!thumb) return;
    var hs = hScroller(thumb);
    if (hs) {
      var tl = thumb.offsetLeft - (hs.clientWidth - thumb.clientWidth) / 2;
      try { hs.scrollTo({ left: Math.max(0, tl), behavior: 'smooth' }); } catch (e) { hs.scrollLeft = Math.max(0, tl); }
    }
    var vs = vScroller(thumb);
    if (vs) {
      var tt = thumb.offsetTop - (vs.clientHeight - thumb.clientHeight) / 2;
      try { vs.scrollTo({ top: Math.max(0, tt), behavior: 'smooth' }); } catch (e) { vs.scrollTop = Math.max(0, tt); }
    }
  }
  var centerT = null;
  function centerSoon(thumb) { if (centerT) clearTimeout(centerT); centerT = setTimeout(function () { centerNow(thumb); }, 90); }
  function bindMain() {
    var g = gallery();
    if (!g || g.main.__djThumbFollow) return;
    g.main.__djThumbFollow = true;
    var scrollT = null;
    g.main.addEventListener('scroll', function () {
      if (scrollT) clearTimeout(scrollT);
      scrollT = setTimeout(function () {
        var w = g.main.clientWidth; if (!w) return;
        var idx = Math.round(g.main.scrollLeft / w);
        if (idx < 0) idx = 0; if (idx > g.thumbs.length - 1) idx = g.thumbs.length - 1;
        centerNow(g.thumbs[idx]);
      }, 140);
    }, { passive: true });
  }
  function bindThumbSelection() {
    var g = gallery();
    if (!g || g.mg.__djThumbSelObs) return;
    g.mg.__djThumbSelObs = true;
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.classList && t.classList.contains('slideshow-controls__thumbnail') && t.getAttribute('aria-selected') === 'true') { centerSoon(t); break; }
      }
    });
    g.thumbs.forEach(function (t) { obs.observe(t, { attributes: true, attributeFilter: ['aria-selected'] }); });
  }

  // Update the ATC-button price live when the main quantity selector changes.
  function bindQty() {
    qa('input[name="quantity"]').forEach(function (inp) {
      if (inp.closest(CARD_SEL) || inp.__djQ) return;
      inp.__djQ = true;
      ['change', 'input'].forEach(function (ev) { inp.addEventListener(ev, function () { injectPrice(); }); });
    });
  }
  var qtyClickBound = false;
  function bindQtyClicks() {
    if (qtyClickBound) return;
    qtyClickBound = true;
    // The +/- buttons update the input value after the click; re-read on a short delay.
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t && t.closest)) return;
      if (t.closest('.quantity-selector, quantity-selector, [class*="quantity"]') && !t.closest(CARD_SEL)) {
        setTimeout(injectPrice, 40);
        setTimeout(injectPrice, 180);
      }
    }, true);
  }

  function boot() {
    installQuickAddFix();
    if (!onProductPage()) return;
    injectPrice();
    bindMain();
    bindThumbSelection();
    bindQty();
    bindQtyClicks();
    var root = document.querySelector('main') || document.body || document.documentElement;
    /* Strypt: en enda omgang 150 ms efter sista andringen, i stallet for en omgang per
       andring. characterData ar borttaget - injectPrice skriver sjalv text i traden och
       matade annars observatoren med sina egna skrivningar. */
    var mo = new MutationObserver(function () {
      if (mo._t) return;
      mo._t = setTimeout(function () {
        mo._t = null;
        try { injectPrice(); bindMain(); bindThumbSelection(); bindQty(); } catch (e) {}
      }, 150);
    });
    try { mo.observe(root, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();

/* 4) REVIEWS PAGINATION: Judge.me collapses and re-expands the list, then animates the
   page to the list top under the sticky header. Jump straight to the list top instead
   and skip Judge.me's own scroll (its jdgmSettings.scrollTo hook) for that page change. */
(function () {
  var skipUntil = 0;
  function wrapScroll() {
    var s = window.jdgmSettings;
    if (!s || s.__djPaginateScroll) return;
    var original = s.scrollTo;
    s.scrollTo = function () {
      if (Date.now() < skipUntil) return false;
      return typeof original === 'function' ? original.apply(this, arguments) : undefined;
    };
    s.__djPaginateScroll = true;
  }
  document.addEventListener('click', function (e) {
    var page = e.target.closest && e.target.closest('#judgeme_product_reviews .jdgm-paginate__page');
    if (!page || page.classList.contains('jdgm-curt')) return;
    wrapScroll();
    skipUntil = Date.now() + 3000;
    var widget = page.closest('#judgeme_product_reviews');
    var target = widget.querySelector('.jdgm-row-actions');
    if (!target || !target.offsetParent) target = widget.querySelector('.jdgm-rev-widg__body');
    if (!target) return;
    var header = document.querySelector('header.shopify-section');
    var offset = 12;
    if (header && /sticky|fixed/.test(getComputedStyle(header).position)) offset += header.getBoundingClientRect().height;
    var top = target.getBoundingClientRect().top + window.scrollY - offset;
    if (top < window.scrollY) window.scrollTo({ top: top, behavior: 'instant' });
  }, true);
})();